"use client";

import * as React from "react";

import { cn } from "@/lib/utils";

type HintTone = "default" | "success";

export type HintNoteProps = {
  children: React.ReactNode;
  icon?: React.ReactNode;
  tone?: HintTone;
  // TODO(learning-mode): pick Option A (add `title?: React.ReactNode`) or
  // Option B (keep children compositional, no title prop). See chat thread.
  className?: string;
};

const TONE_CLASS: Record<HintTone, string> = {
  default: "border-border/70 bg-muted/20 text-muted-foreground",
  success: "border-emerald-200 bg-emerald-50/80 text-emerald-900",
};

export function HintNote({
  children,
  icon,
  tone = "default",
  className,
}: HintNoteProps) {
  // TODO(learning-mode): if Option A, render <p className="mb-0.5 text-foreground">{title}</p>
  // above {children}, and switch icon alignment to items-start when title is present
  // (so the icon sits next to the title, not vertically centered against the whole block).
  return (
    <div
      className={cn(
        "rounded-md border px-4 py-3 text-xs font-medium leading-relaxed",
        icon ? "flex items-center gap-2" : "",
        TONE_CLASS[tone],
        className,
      )}
    >
      {icon ? <div className="shrink-0">{icon}</div> : null}
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
